import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import bannerImage from '@flipster/features/src/earn-page/get-premium-usdt/banner.webp';
import { pusdtAgreementBunja } from '@flipster/features/src/earn-page/get-premium-usdt/bunja';
import { earnSummaryBunja, getEarnSummaryOfCurrency } from '@flipster/features/src/shared/earn/state';
import { TextButton } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { Button } from '@flipster/react/design-system/button';
import BoltIcon from '@flipster/react/icon/generated/BoltIcon';
import { css } from '@flipster/styled-system/css';
import { center, flex } from '@flipster/styled-system/patterns';
import { PusdtCurrency, PusdtDisplayName, UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

interface Props {
  onClickNext: () => void;
  goToTerms: () => void;
}

const InfoStep = ({ goToTerms, onClickNext }: Props) => {
  const { isAgreedPusdtAtom, getPremiumEarnInfo } = useBunja(pusdtAgreementBunja);
  const isAgreedPusdt = useAtomValue(isAgreedPusdtAtom);
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const earnSummary = useAtomValue(earnSummaryAtom);
  const pusdtMaxAprPct = getEarnSummaryOfCurrency(PusdtCurrency, earnSummary).maxAprPct;

  return (
    <>
      <Modal.Content>
        <div className={flex({ flexDir: 'column', color: 'content.default.level-4' })}>
          <img
            src={bannerImage.src}
            alt='get-premium-usdt'
            width={237}
            height={237}
            className={css({ alignSelf: 'center' })}
          />
          <div className={css({ textStyle: 'Title/L', mt: 10, whiteSpace: 'pre-line' })}>
            <p>Upgrade up to {numberFormatter(pusdtMaxAprPct, { precision: UsdtPrecision })}% APR</p>
            <p className={css({ mt: 8 })}>with {PusdtDisplayName}</p>
          </div>
          <ul className={css({ mt: 24 })}>
            {getPremiumEarnInfo(pusdtMaxAprPct.toString()).map((item) => (
              <li key={item.title} className={flex({ align: 'center', gap: 8, '& + &': { mt: 24 } })}>
                <BoltIcon size={24} />
                <div className={css({ flex: 1 })}>
                  <p className={css({ textStyle: 'Text/L/Strong', mb: 4 })}>{item.title}</p>
                  <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-2' })}>
                    {item.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        {isAgreedPusdt && (
          <div className={center({ mt: 48 })}>
            <TextButton
              as='button'
              color='passive'
              size='medium'
              label={`${PusdtDisplayName} terms and conditions`}
              css={{ textAlign: 'center' }}
              onClick={goToTerms}
            />
          </div>
        )}
      </Modal.Content>
      <Modal.Footer>
        <Button label='Add USDT now' hierarchy='primary' color='accent' onClick={onClickNext} />
      </Modal.Footer>
    </>
  );
};

export default InfoStep;
